<template>
  <div v-loading="request">

    <el-alert v-if="errorCode" type="error" :title="$t(errorCode)" show-icon />

    <h3 class="section__title" v-if="results.length">{{ $t('searchResultsTitle') }}</h3>

    <el-table v-if="query.length && !request && !errorCode" class="table" :data="results"
      :empty-text="$t('searchNoResults')" @row-click="rowClicked" row-class-name="search__result--row" :showHeader=false>
      <el-table-column class-name="search__result--title" prop="title" />
      <el-table-column class-name="search__result--type" prop="type" :formatter="formatType" align="right" width="120" />
    </el-table>

    <el-alert v-else :title="$t('searchResultsBeforeTitle')" :description="$t('searchResultsBeforeDescription')"
      type="info" show-icon :closable="false" />

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import i18n from '@/configured/vue-i18n/i18n';
import search from '.';
import { buildProductDetailRoute } from '@/components/products/product.util';

export default {
  name: 'SearchResults',
  computed: {
    ...mapState(search.store.namespace, [
      'results',
      'request',
      'errorCode',
      'query',
    ]),
  },
  methods: {
    formatType,
    rowClicked,
  }
}

function rowClicked(row, event, column) {
  if (row.type === 'products') {
    return this.$router.push(
      buildProductDetailRoute({
        id: row.id,
        slug: row.slug,
        title: row.title,
      }),
    );
  } else if (row.type === 'trainingModules') {
    return this.$router.push({ name: 'TrainingModuleDetail', params: { id: row.id } });
  }
}

function formatType(row, column, value) {
  if (value === 'products') {
    return i18n.t('menuProducts');
  }
}
</script>

<style lang="scss">
@import '@/assets/base/_variables.scss';

.search {

  &__result {

    &--row {
      cursor: pointer;
    }

    &--title {
      font-weight: 700;
    }

    &--type {
      text-transform: uppercase;
      letter-spacing: $--serif-letter-spacing;
    }
  }
}
</style>
